import React from 'react';

import { SvgIcon } from '@material-ui/core';

function KingpinIcon() {
  return (
    <SvgIcon>
      <path
        d="M 17.18,7.40
           C 17.18,7.40 18.50,3.48 18.50,3.48
             18.54,3.35 18.36,3.24 18.21,3.31
             18.21,3.31 15.14,4.73 15.14,4.73
             15.14,4.73 12.14,0.58 12.14,0.58
             12.07,0.47 11.88,0.47 11.81,0.58
             11.81,0.58 8.81,4.73 8.81,4.73
             8.81,4.73 5.78,3.32 5.78,3.32
             5.63,3.25 5.45,3.36 5.50,3.49
             5.50,3.49 6.79,7.37 6.79,7.37
             6.98,7.10 7.21,6.84 7.46,6.61
             8.11,6.00 8.95,5.53 9.90,5.24
             10.55,5.05 11.25,4.94 11.97,4.94
             12.70,4.94 13.40,5.05 14.04,5.24
             15.00,5.52 15.84,6.00 16.49,6.61
             16.49,6.61 16.49,6.61 16.49,6.61
             16.76,6.85 16.99,7.12 17.18,7.40 Z
           M 14.43,7.57
           C 14.98,8.08 15.31,8.75 15.36,9.46
             15.36,9.53 15.36,9.61 15.36,9.69
             15.33,10.47 14.96,11.33 14.65,12.11
             14.56,12.32 14.48,12.58 14.40,12.82
             14.49,14.46 16.74,15.80 17.19,18.05
             17.53,19.73 16.76,22.18 14.74,23.50
             14.74,23.50 11.98,23.50 11.98,23.50
             11.98,23.50 11.79,23.50 11.79,23.50
             11.79,23.50 9.02,23.50 9.02,23.50
             7.01,22.18 6.24,19.73 6.57,18.05
             7.03,15.80 9.28,14.46 9.36,12.82
             9.36,12.82 9.36,12.82 9.36,12.82
             9.28,12.58 9.20,12.32 9.12,12.11
             8.80,11.33 8.43,10.47 8.41,9.69
             8.40,9.61 8.40,9.53 8.41,9.46
             8.45,8.74 8.78,8.08 9.34,7.57
             9.36,7.55 9.38,7.53 9.40,7.52
             9.82,7.15 10.34,6.89 10.93,6.76
             11.20,6.70 11.50,6.66 11.81,6.66
             11.81,6.66 11.81,6.66 11.81,6.66
             11.82,6.66 11.83,6.66 11.84,6.66
             11.85,6.66 11.86,6.66 11.88,6.66
             11.88,6.66 11.89,6.66 11.90,6.66
             11.91,6.66 11.92,6.66 11.94,6.66
             11.95,6.66 11.96,6.66 11.96,6.66
             11.96,6.66 11.96,6.66 11.96,6.66
             12.91,6.67 13.75,6.97 14.38,7.52
             14.39,7.53 14.41,7.55 14.43,7.57 Z"
      />
    </SvgIcon>
  );
}

export default KingpinIcon;
